// Unsplash destination hero images — keyed by city name for uniqueness
// All images are free via Unsplash source URLs (no API key needed)
const destImages = {
  // Europe
  'Dubrovnik + Hvar': 'https://images.unsplash.com/photo-1555990538-1e7e5c230569?w=800&h=400&fit=crop',
  'Santorini + Athens': 'https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?w=800&h=400&fit=crop',
  'Amalfi Coast + Rome': 'https://images.unsplash.com/photo-1534308983496-4fabb1a015ee?w=800&h=400&fit=crop',
  'Lisbon + Porto': 'https://images.unsplash.com/photo-1555881400-74d7acaacd8b?w=800&h=400&fit=crop',
  'Barcelona + Ibiza': 'https://images.unsplash.com/photo-1583422409516-2895a77efded?w=800&h=400&fit=crop',
  'Nice + Monaco': 'https://images.unsplash.com/photo-1533104816931-20fa691ff6ca?w=800&h=400&fit=crop',
  'London + Cotswolds': 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=800&h=400&fit=crop',
  'Paris': 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=800&h=400&fit=crop',
  'Reykjavik + Golden Circle': 'https://images.unsplash.com/photo-1504829857797-ddff29c27927?w=800&h=400&fit=crop',
  'Dublin + Cliffs of Moher': 'https://images.unsplash.com/photo-1590089415225-401ed6f9db8e?w=800&h=400&fit=crop',
  'Amsterdam': 'https://images.unsplash.com/photo-1534351590666-13e3e96b5017?w=800&h=400&fit=crop',
  // Caribbean & Americas
  'Turks & Caicos': 'https://images.unsplash.com/photo-1548574505-5e239809ee19?w=800&h=400&fit=crop',
  'Cancun + Tulum': 'https://images.unsplash.com/photo-1510097467424-192d713fd8b2?w=800&h=400&fit=crop',
  'Costa Rica': 'https://images.unsplash.com/photo-1519999482648-25049ddd37b1?w=800&h=400&fit=crop',
  'Cartagena': 'https://images.unsplash.com/photo-1533050487297-09b450131914?w=800&h=400&fit=crop',
  'Aruba': 'https://images.unsplash.com/photo-1548574505-5e239809ee19?w=800&h=400&fit=crop',
  'Bermuda': 'https://images.unsplash.com/photo-1559599238-308793637427?w=800&h=400&fit=crop',
  'Azores': 'https://images.unsplash.com/photo-1500595046743-cd271d694d30?w=800&h=400&fit=crop',
};

export default destImages;
